import { HOME_DISCLOSURES_STRINGS } from 'accounts/constants/strings/home-disclosures.strings';
import { DateInputFinalFormAdapter } from 'components/DateInput/DateInput';
import Field from 'components/Field/Field';
import { InputFinalFormAdapter } from 'components/Input/Input';
import { maskMMDDYYYY, unmaskMMDDYYYY } from 'components/Input/masks';
import {
  MEDIA_LABEL,
  NewMediaUploadAdapter,
} from 'components/NewMediaUploader/NewMediaUploader';
import { Col, Row } from 'forkedlibraries/react-bootstrap';
import {
  composeValidators,
  dateValidationMMDDYY,
  required,
} from 'utils/validation';

type HousingCodeViolationFieldsProps = {
  // The per-row field prefix supplied by StandardFieldArray
  // (e.g. `disclosures.types.HousingCodeViolations.housingCodeViolations[0]`).
  name: string;
};

// A single DC housing-code violation row: date, code section, location, and an
// optional notice file. The uploaded notice is persisted per row via
// `fileUniqueId` and included in the disclosure's documents payload on submit
// (see accounts/utils/disclosures.ts + store/redux/homeowner-set-up-flow).
export function HousingCodeViolationFields({
  name,
}: HousingCodeViolationFieldsProps) {
  return (
    <div>
      <Row>
        <Col xs={24} sm={12} md={6}>
          <Field
            name={`${name}.date`}
            component={DateInputFinalFormAdapter}
            mask={maskMMDDYYYY}
            unmask={unmaskMMDDYYYY}
            placeholder={HOME_DISCLOSURES_STRINGS['housing_code.date']}
            validate={composeValidators(required, dateValidationMMDDYY)}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Field
            name={`${name}.codeSection`}
            component={InputFinalFormAdapter}
            placeholder={HOME_DISCLOSURES_STRINGS['housing_code.code_section']}
            validate={required}
          />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Field
            name={`${name}.location`}
            component={InputFinalFormAdapter}
            placeholder={HOME_DISCLOSURES_STRINGS['housing_code.location']}
          />
        </Col>
      </Row>
      <div className="mt-lg">
        <Field
          name={`${name}.file`}
          component={NewMediaUploadAdapter}
          mediaLabel={MEDIA_LABEL.FILE_UPLOAD}
          customLabel={HOME_DISCLOSURES_STRINGS['housing_code.file_label']}
          disableWebcam
          cleanOnMediaChange
          isSingleMedia
        />
      </div>
    </div>
  );
}
